import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'tailwindcss/tailwind.css'
import './styles/global.css'
import VueSweetalert2 from 'vue-sweetalert2'

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'

axios.defaults.baseURL = process.env.VUE_APP_BASE_PATH
Vue.config.productionTip = false
Vue.use(Vuex)

Vue.use(VueSweetalert2)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
